// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Carte de France interactive (selecteur de perimetre) */

.france-map {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.france-map-canvas {
  position: relative;
  width: 100%;
}

/* Voile de sauvegarde : bloque le clic (pointer-events) et clignote. */
.france-map-svg.is-locked {
  pointer-events: none;
}

.france-map-saving {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.45);
  cursor: progress;
  animation: france-map-pulse 1s ease-in-out infinite;
}

.france-map-saving-pill {
  padding: 0.6rem 1.4rem;
  border-radius: 999px;
  background: #1f2937;
  color: #fff;
  font-size: 1.3rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

@keyframes france-map-pulse {
  0%, 100% { opacity: 0.55; }
  50% { opacity: 1; }
}

.france-map-svg {
  width: 100%;
  height: auto;
  max-height: 52rem;
  display: block;
}

.france-dept {
  fill: #e5e7eb;
  stroke: #fff;
  stroke-width: 0.8;
  cursor: pointer;
  transition: fill 0.32s ease;
}

.france-dept:hover {
  fill: #d1d5db;
}

.france-dept--isole {
  fill: #fdba74;
}

.france-dept--isole:hover {
  fill: #fb923c;
}

.france-dept--region {
  fill: #f97316;
}

.france-dept--region:hover {
  fill: #ea580c;
}

.france-dept.is-disabled {
  cursor: default;
}

.france-map-tooltip {
  position: fixed;
  z-index: 50;
  pointer-events: none;
  background: #1f2937;
  color: #fff;
  font-size: 1.2rem;
  padding: 0.4rem 0.8rem;
  border-radius: 0.5rem;
  white-space: nowrap;
}

/* Outre-mer : pastilles cliquables */
.france-map-outremer {
  display: block;
}

.france-map-outremer-label {
  display: block;
  margin-bottom: 0.6rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

/* Mini-cartes DOM : chaque DOM avec sa propre geometrie, cliquable */
.france-map-dom-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  gap: 0.75rem;
}

.france-dom-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  padding: 0.75rem 0.5rem;
  /* border: 1px solid #e5e7eb; */
  border-radius: 0.7rem;
  /* background: #fff; */
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s;
}

.france-dom-card:hover {
  border-color: #d1d5db;
  background: #f9fafb;
}

.france-dom-card--isole {
  border-color: #fdba74;
  background: #fff7ed;
}

.france-dom-card--region {
  border-color: #f97316;
  background: #fff7ed;
}

.france-dom-card:disabled {
  cursor: progress;
}

.france-dom-svg {
  width: 100%;
  height: 5.5rem;
}

.france-dom-svg .france-dept {
  stroke: #fff;
  stroke-width: 1.2;
}

.france-dom-name {
  font-size: 1.15rem;
  color: #374151;
  text-align: center;
  line-height: 1.2;
}

/* Legende */
.france-map-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
}

.france-legend-item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.2rem;
  color: #6b7280;
}

.france-legend-swatch {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.france-legend-swatch--region { background: #f97316; }
.france-legend-swatch--isole { background: #fdba74; }
.france-legend-swatch--libre { background: #e5e7eb; }
`, "",{"version":3,"sources":["webpack://./src/composants/PerimetreSelector/FranceMap.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,uEAAuE;AACvE;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,gCAAgC,mBAAmB,EAAE;AACrD,+BAA+B,mBAAmB,EAAE;AACpD,+BAA+B,mBAAmB,EAAE","sourcesContent":["/* Carte de France interactive (selecteur de perimetre) */\n\n.france-map {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.france-map-canvas {\n  position: relative;\n  width: 100%;\n}\n\n/* Voile de sauvegarde : bloque le clic (pointer-events) et clignote. */\n.france-map-svg.is-locked {\n  pointer-events: none;\n}\n\n.france-map-saving {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.45);\n  cursor: progress;\n  animation: france-map-pulse 1s ease-in-out infinite;\n}\n\n.france-map-saving-pill {\n  padding: 0.6rem 1.4rem;\n  border-radius: 999px;\n  background: #1f2937;\n  color: #fff;\n  font-size: 1.3rem;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@keyframes france-map-pulse {\n  0%, 100% { opacity: 0.55; }\n  50% { opacity: 1; }\n}\n\n.france-map-svg {\n  width: 100%;\n  height: auto;\n  max-height: 52rem;\n  display: block;\n}\n\n.france-dept {\n  fill: #e5e7eb;\n  stroke: #fff;\n  stroke-width: 0.8;\n  cursor: pointer;\n  transition: fill 0.32s ease;\n}\n\n.france-dept:hover {\n  fill: #d1d5db;\n}\n\n.france-dept--isole {\n  fill: #fdba74;\n}\n\n.france-dept--isole:hover {\n  fill: #fb923c;\n}\n\n.france-dept--region {\n  fill: #f97316;\n}\n\n.france-dept--region:hover {\n  fill: #ea580c;\n}\n\n.france-dept.is-disabled {\n  cursor: default;\n}\n\n.france-map-tooltip {\n  position: fixed;\n  z-index: 50;\n  pointer-events: none;\n  background: #1f2937;\n  color: #fff;\n  font-size: 1.2rem;\n  padding: 0.4rem 0.8rem;\n  border-radius: 0.5rem;\n  white-space: nowrap;\n}\n\n/* Outre-mer : pastilles cliquables */\n.france-map-outremer {\n  display: block;\n}\n\n.france-map-outremer-label {\n  display: block;\n  margin-bottom: 0.6rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n/* Mini-cartes DOM : chaque DOM avec sa propre geometrie, cliquable */\n.france-map-dom-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));\n  gap: 0.75rem;\n}\n\n.france-dom-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.75rem 0.5rem;\n  /* border: 1px solid #e5e7eb; */\n  border-radius: 0.7rem;\n  /* background: #fff; */\n  cursor: pointer;\n  transition: border-color 0.12s, background 0.12s;\n}\n\n.france-dom-card:hover {\n  border-color: #d1d5db;\n  background: #f9fafb;\n}\n\n.france-dom-card--isole {\n  border-color: #fdba74;\n  background: #fff7ed;\n}\n\n.france-dom-card--region {\n  border-color: #f97316;\n  background: #fff7ed;\n}\n\n.france-dom-card:disabled {\n  cursor: progress;\n}\n\n.france-dom-svg {\n  width: 100%;\n  height: 5.5rem;\n}\n\n.france-dom-svg .france-dept {\n  stroke: #fff;\n  stroke-width: 1.2;\n}\n\n.france-dom-name {\n  font-size: 1.15rem;\n  color: #374151;\n  text-align: center;\n  line-height: 1.2;\n}\n\n/* Legende */\n.france-map-legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.25rem;\n}\n\n.france-legend-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.2rem;\n  color: #6b7280;\n}\n\n.france-legend-swatch {\n  width: 1.4rem;\n  height: 1.4rem;\n  border-radius: 0.3rem;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.france-legend-swatch--region { background: #f97316; }\n.france-legend-swatch--isole { background: #fdba74; }\n.france-legend-swatch--libre { background: #e5e7eb; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
